import * as React from 'react';

export const AppraisalEvaluationTab = () => {
  return <div>TBA tab content: AppraisalEvaluationTab</div>;
};
